import * as z from "zod";
import { userFacingError } from "../authorization";
import {
  presentedCertificateFetchId,
  presentedCertificateRequestedAt,
  presentedCertificateStatus,
  withoutPresentedCertificate,
} from "../connectors/presentedCertificate";
import { isFeatureFlagEnabled } from "../featureFlags";
import { CONNECTOR_CERTIFICATE_TRUST_FLAG } from "../featureFlagNames";
import { clientGeneratableIdSchema } from "../id";
import { mutator } from "./mutator";

export const fetchConnectorCertificateSchema = z.object({
  connectedAppId: z.string(),
  fetchId: clientGeneratableIdSchema,
});

export const fetchConnectorCertificate = mutator({
  schema: fetchConnectorCertificateSchema,
  resolve: {
    app: { kind: "connectedApp", from: "connectedAppId" },
  },
  permissions: [
    {
      permission: "connected_app:write",
      scopeId: ({ args }) => args.app.id,
    },
  ],
  description:
    "Fetches the certificate a connector’s server presents so the user can review and trust it.",
  interactionType: "review",
  fn: async ({ tx, ctx, args: { app, fetchId } }) => {
    if (
      !(await isFeatureFlagEnabled(
        tx,
        CONNECTOR_CERTIFICATE_TRUST_FLAG,
        ctx.tenantId
      ))
    ) {
      throw userFacingError(
        "Fetching server certificates isn’t available for this tenant."
      );
    }
    await tx.mutate.connectedApps.update({
      id: app.id,
      metadata: {
        ...withoutPresentedCertificate(app.metadata),
        [presentedCertificateStatus]: "pending",
        [presentedCertificateFetchId]: fetchId,
        [presentedCertificateRequestedAt]: String(Date.now()),
      },
    });
  },
});
